import React from 'react';
import { ReactCompareSlider, ReactCompareSliderImage } from 'react-compare-slider';

const BeforeAfterSection = () => {
  return (
    <div
      style={{
        maxWidth: 1150,
        margin: '0 auto',
        padding: '80px 40px',
      }}
    >
      <h2
        style={{
          fontFamily: 'Montserrat, sans-serif',
          fontWeight: 300,
          fontSize: 'clamp(18px, 3vw, 28px)',
          color: '#ffffff',
          letterSpacing: '0.15em',
          textTransform: 'uppercase',
          textAlign: 'center',
          marginBottom: 16,
        }}
      >
        See the Difference
      </h2>
      <p
        style={{
          fontFamily: 'Montserrat, sans-serif',
          fontWeight: 300,
          fontSize: 'clamp(12px, 1.5vw, 16px)',
          color: 'rgba(255,255,255,0.5)',
          textAlign: 'center',
          letterSpacing: '0.06em',
          marginBottom: 48,
        }}
      >
        Drag to compare before &amp; after colour grading
      </p>
      <div
        style={{
          borderRadius: 4,
          overflow: 'hidden',
          border: '1px solid rgba(255,255,255,0.08)',
        }}
      >
        <ReactCompareSlider
          itemOne={
            <ReactCompareSliderImage
              src="/images/shop/compare/before.jpg"
              alt="Before colour grading"
              style={{ objectFit: 'cover' }}
            />
          }
          itemTwo={
            <ReactCompareSliderImage
              src="/images/shop/compare/after.jpg"
              alt="After colour grading"
              style={{ objectFit: 'cover' }}
            />
          }
          style={{
            width: '100%',
            aspectRatio: '16/9',
          }}
          handle={
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100%',
              }}
            >
              <div
                style={{
                  width: 2,
                  height: '100%',
                  background: 'rgba(255,255,255,0.7)',
                  position: 'relative',
                }}
              >
                <div
                  style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: 40,
                    height: 40,
                    borderRadius: '50%',
                    background: 'rgba(0,0,0,0.6)',
                    border: '2px solid rgba(255,255,255,0.7)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backdropFilter: 'blur(4px)',
                    cursor: 'ew-resize',
                  }}
                >
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M5 3L1 8L5 13" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M11 3L15 8L11 13" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </div>
              </div>
            </div>
          }
        />
      </div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          marginTop: 12,
          fontFamily: 'Montserrat, sans-serif',
          fontWeight: 300,
          fontSize: 12,
          color: 'rgba(255,255,255,0.35)',
          letterSpacing: '0.1em',
          textTransform: 'uppercase',
        }}
      >
        <span>Before</span>
        <span>After</span>
      </div>
    </div>
  );
};

export default BeforeAfterSection;
